import cookies from "js-cookie";

export const offersDrawerOpenedCookie = "offersDrawerOpened";

export const getCookieDrawerOpen = () => {
  if (typeof window !== "undefined") {
    const encodedoffersDrawerOpened = cookies.get(offersDrawerOpenedCookie);
    try {
      if (encodedoffersDrawerOpened) {
        return true;
      }
    } catch (err) {
      return false;
    }
  }
  return false;
};

export const setCookieDrawerOpen = () => {
  cookies.set(offersDrawerOpenedCookie, window.btoa("true"), {
    path: "/",
    secure: true,
  });
};
